export default __webpack_public_path__ + "static/media/alarm1.50a3a0b3.mp3";